import { render, staticRenderFns } from "./FacturaVenta.vue?vue&type=template&id=86b17804&scoped=true"
import script from "./FacturaVenta.vue?vue&type=script&lang=js"
export * from "./FacturaVenta.vue?vue&type=script&lang=js"
import style0 from "./FacturaVenta.vue?vue&type=style&index=0&id=86b17804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b17804",
  null
  
)

export default component.exports